import schools from "@/assets/escuelas.json"

export default {
    
    getSchools() {
        return schools
    },

    getSchoolsByCity(idCity) {
        return schools.filter(ele => ele.municipio == idCity)
    },

    getSchool(id) {
        return schools.find(ele => ele.id == id)
    }
}